import React, { useState, useEffect } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
	useTheme,
	useMediaQuery,
} from '@material-ui/core';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { toggleGSTModal, toggleTermModal } from '../../reducers/UiReducer';
import { useDispatch } from 'react-redux';
import AddGSTModal from '../../components/reusableComponents/AddGSTModal';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SelectedOnwardTJKRow from '../../components/reusableComponents/SelectedOnwardTJKRow';
import TermConditionModal from '../../components/reusableComponents/TermConditionModal';
import FlightConfirmForm from '../../form/FlightConfirmForm';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import ErrorModal from '../../components/reusableComponents/ErrorModal';
import SelectedOnwardEtravRow from '../../components/reusableComponents/SelectedOnwardEtravRow';
import SelectedReturnEtravRow from '../../components/reusableComponents/SelectedReturnEtravRow';
import SelectedOnwardTboRow from '../../components/reusableComponents/SelectedOnwardTboRow';
import FlightConfirmReturnForm from '../../form/FlightConfirmReturnForm';
import Footer from './Footer';
import { fetchCurrencyDispatch } from '../../reducers/HomeReducer';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const ConfirmFlight = () => {
	const classes = useStyles();
	const [value, setValue] = React.useState('');
	const [val, setVal] = React.useState(false);
	const [b, setB] = React.useState(false);
	const { etravflightFare, baggageInfo, mealInfo,curr } = useSelector(
		(state) => state.ui
	);
	const {currency} = useSelector((state)=>state.home)
	const location = useLocation();
	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleChange = (event) => {
		setValue(event.target.value);
	};
	// const Convert = Number(curr==='INR'?currency.conversion_rates.INR:curr==='USD'?currency.conversion_rates.USD:curr==='AFN'?currency.conversion_rates.AFN:1)
	const {
		baggage,
		baggageAdult1,
		baggageAdult2,
		baggageAdult3,
		baggageAdult4,
		baggageAdult5,
		baggageAdult6,
		baggageAdult7,
		baggageAdult8,
		baggageAdult9,
		baggageChild1,
		baggageChild2,
		baggageChild3,
		baggageChild4,
		baggageChild5,
		baggageChild6,

		mealAdult1,
		mealAdult2,
		mealAdult3,
		mealAdult4,
		mealAdult5,
		mealAdult6,
		mealAdult7,
		mealAdult8,
		mealAdult9,
		mealChild1,
		mealChild2,
		mealChild3,
		mealChild4,
		mealChild5,
		mealChild6,
	} = useSelector((state) => state.ui);
	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		// if (gst) {
		dispatch(toggleTermModal(true));
		// }

		// setCheck(event.target.checked);
	};
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log('Loc', location);
	function convertH2M(timeInHour) {
		console.log(timeInHour);
		var timeParts = timeInHour.split(':');
		return Number(timeParts[0]) * 60 + Number(timeParts[1]);
	}
	// 	let etrav2 =
	//     location.state.selectedonward[0].Airline_Code &&
	//     location.state.selectedReturn[0].Airline_Code;
	//   let etrvotbor =
	//     location.state.selectedonward[0].Airline_Code &&
	//     location.state.selectedReturn[0].AirlineCode;
	//   let etravrtboo =
	//     location.state.selectedReturn[0].Airline_Code &&
	//     location.state.selectedonward[0].AirlineCode;
	//   let tbo2 =
	//     location.state.selectedonward[0].AirlineCode &&
	//     location.state.selectedReturn[0].AirlineCode;
	// 	console.log(location);
	const handleClick = (event) => {
		if (event.target.value === value) {
			setValue('');
		} else {
			setValue(event.target.value);
		}
	};
	useEffect(() => {
		window.scrollTo(0, 0); 
		// dispatch(fetchCurrencyDispatch())
	}, []);
	return (
		<>
			<Box
				style={{
					paddingTop: '10px',
					// background: 'white',
					position: 'absolute',
					zIndex: 99,
					height: 60,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				}}>
				<Container>
					<HeaderSection id={1} />
				</Container>
			</Box>
			<Box
				style={{
					backgroundColor: '#515b62',
					marginTop: 75,
					color: 'white',
					padding: 10,
				}}>
				<Container>
					{/* <Box display='flex'>
						<TitleText three>MusafirBazar Holiday /</TitleText>
						<TitleText three textStyle={{ marginLeft: 5 }}>
							Flight / Confirm
						</TitleText>
					</Box> */}
				</Container>
			</Box>
			<Box style={{ background: '#e5eef4', paddingLeft: 30, paddingRight: 30 }}>
				{/* <Container> */}
				<Grid container spacing={2}>
					<Grid item xs={12} lg={8}>
						<Box display='flex' justifyContent='space-between' mt={'30px'}>
							<Box>
								<TitleText
									four
									textStyle={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										fontSize: 22,
									}}>
									Confirm Your Booking
								</TitleText>
							</Box>
						</Box>
						<Box
							style={{
								padding: 15,
								background: 'white',
								color: 'gray',
								border: '1px solid #e6e6e6',
								margin: '0 0 20px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							{location.state.OneflightData
								? location.state.OneflightData.Airline_Code
									? location.state.OneflightData.Segments.map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{location.state.OneflightData.Origin}
																</TitleText>
																-
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{location.state.OneflightData.Destination}
																</TitleText>
															</Box>
															{index === 0 ? (
																<Box
																	ml={'30px'}
																	style={{
																		background: 'rgb(239, 51, 57)',
																		padding: '3px 15px',
																		borderRadius: '50px',
																		color: 'white',
																		fontFamily: 'unset',
																		fontWeight: 500,
																	}}>
																	<TitleText two>ONWARD</TitleText>
																</Box>
															) : (
																''
															)}
														</Box>
														<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText three textStyle={{ fontSize: 16 }}>
															{' '}
															{`${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).getDate()} ${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																month: 'short',
															})},2022`}
														</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 5,
														}}>
														<Grid container style={{ alignItems: 'center' }}>
															<Grid item xs={12} sm={3} lg={3}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Origin_City}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 600,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.Departure_DateTime.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ marginTop: matches ? 10 : '' }}>
																<Box
																	style={{
																		padding: '2px 20px',
																		background: 'rgb(239, 51, 57)',
																		color: 'white',
																		borderRadius: 25,
																	}}>
																	<BodyText
																		three
																		textStyle={{
																			fontSize: 16,
																			textAlign: 'center',
																			whiteSpace: 'nowrap',
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																		}}>
																		{timeConvert(convertH2M(i.Duration))}
																	</BodyText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{
																	textAlign: 'center',
																	marginTop: matches ? 10 : '',
																}}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Destination_City}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 600,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.Arrival_DateTime.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ textAlign: 'center' }}>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
																	width='100px'
																	height='80px'></img>
																<p>{`${i.Airline_Name} (${i.Airline_Code}-${i.Flight_Number})`}</p>
															</Grid>
														</Grid>

														{/* <Grid item xs={12} sm={3} lg={3}>
                              <Box textAlign="center" display='flex'>
                                <img
                                  src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
                                  width="50px"
                                  height="25px"
                                ></img>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  {i.Airline_Name}
                                </BodyText>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  {i.Airline_Code}-{i.Flight_Number}| Economy
                                </BodyText>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  Check-In : 1Pc - 15Kgs
                                </BodyText>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  Cabin : 7Kgs
                                </BodyText>
                              </Box>
                            </Grid> */}
													</Box>
												</>
											);
									  })
									: location.state.OneflightData.AirlineCode
									? location.state.OneflightData.Segments[0].map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.Origin.Airport.CityCode}
																</TitleText>
																-
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{index == 0
																		? location.state.OneflightData.Segments[0]
																				.filter((i, ind) => ind === 0)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 1
																		? location.state.OneflightData.Segments[0]
																				.filter((i, ind) => ind === 1)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 2
																		? location.state.OneflightData.Segments[0]
																				.filter((i, ind) => ind === 2)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: ''}
																</TitleText>
															</Box>
															{index === 0 ? (
																<Box
																	ml={'30px'}
																	style={{
																		background: 'rgb(239, 51, 57)',
																		padding: '3px 15px',
																		borderRadius: '50px',
																		color: 'white',
																		fontFamily: 'unset',
																		fontWeight: 500,
																	}}>
																	<TitleText two>ONWARD</TitleText>
																</Box>
															) : (
																''
															)}
														</Box>
														<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText three textStyle={{ fontSize: 16 }}>
															{' '}
															{`${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).getDate()} ${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																month: 'short',
															})},2022`}
														</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 5,
														}}>
														<Grid container style={{ alignItems: 'center' }}>
															<Grid item xs={12} sm={3} lg={3}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Origin.Airport.CityName}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 600,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.Origin.DepTime.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ marginTop: matches ? 10 : '' }}>
																<Box
																	style={{
																		padding: '2px 20px',
																		background: 'rgb(239, 51, 57)',
																		color: 'white',
																		borderRadius: 25,
																	}}>
																	<BodyText
																		three
																		textStyle={{
																			fontSize: 16,
																			textAlign: 'center',
																			whiteSpace: 'nowrap',
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																		}}>
																		{timeConvert(i.Duration)}
																	</BodyText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{
																	textAlign: 'center',
																	marginTop: matches ? 10 : '',
																}}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Destination.Airport.CityName}
																		{/* {i.Destination_City} */}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.Destination.ArrTime.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ textAlign: 'center' }}>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
																	width='50px'
																	height='25px'></img>
																<p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
															</Grid>
														</Grid>
														{/* <Grid container>
                              <Grid item xs={12} sm={9} lg={9}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Origin.Airport.CityName}(
                                      {i.Origin.Airport.AirportCode})
                                    </TitleText>
                                    <BodyText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Origin.Airport.AirportName}
                                    </BodyText>
                                  </Box>
                                  <Box>
                                    <TitleText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Origin.DepTime.substr(11, 5)}
                                    </TitleText>
                                  </Box>
                                </Box>
                                <Grid container alignItems="center">
                                  <Grid item xs={6} lg={9}>
                                    <Divider />
                                  </Grid>
                                  <Grid item xs={4} lg={3}>
                                    <Box
                                      style={{
                                        padding: "2px 20px",
                                        background: "rgb(239, 51, 57)",
                                        color: "white",
                                        borderRadius: 5,
                                      }}
                                    >
                                      <BodyText three>
                                        {timeConvert(i.Duration)}
                                      </BodyText>
                                    </Box>
                                  </Grid>
                                </Grid>

                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Destination.Airport.CityName}(
                                      {i.Destination.Airport.AirportCode})
                                    </TitleText>
                                    <BodyText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Destination.Airport.AirportName}
                                    </BodyText>
                                  </Box>
                                  <Box>
                                    <TitleText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Destination.ArrTime.substr(11, 5)}
                                    </TitleText>
                                  </Box>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3}>
                                <Box textAlign="center">
                                  <img
                                    src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                                    width="50px"
                                    height="25px"
                                  ></img>
                                  <BodyText three>
                                    {i.Airline.AirlineName}
                                  </BodyText>
                                  <BodyText three>
                                    {i.Airline.AirlineCode}-
                                    {i.Airline.FlightNumber}| Economy
                                  </BodyText>
                                  <BodyText three>
                                    Check-In : 1Pc - 15Kgs
                                  </BodyText>
                                  <BodyText three>Cabin : 7Kgs</BodyText>
                                </Box>
                              </Grid>
                            </Grid> */}
													</Box>
												</>
											);
									  })
									: location.state.OneflightData.Supplier === 'TJK'
									? location.state.OneflightData.sI.map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.da.cityCode}
																</TitleText>
																-
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{index == 0
																		? location.state.OneflightData.sI
																				.filter((i, ind) => ind === 0)
																				.map((one) => {
																					return one.aa.cityCode;
																				})
																		: index == 1
																		? location.state.OneflightData.sI
																				.filter((i, ind) => ind === 1)
																				.map((one) => {
																					return one.aa.cityCode;
																				})
																		: index == 2
																		? location.state.OneflightData.sI
																				.filter((i, ind) => ind === 2)
																				.map((one) => {
																					return one.aa.cityCode;
																				})
																		: ''}
																</TitleText>
															</Box>
															{index === 0 ? (
																<Box
																	ml={'30px'}
																	style={{
																		background: 'rgb(239, 51, 57)',
																		padding: '3px 15px',
																		borderRadius: '50px',
																		color: 'white',
																		fontFamily: 'unset',
																		fontWeight: 500,
																	}}>
																	<TitleText two>ONWARD</TitleText>
																</Box>
															) : (
																''
															)}
														</Box>
														<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText three textStyle={{ fontSize: 16 }}>
															{' '}
															{`${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).getDate()} ${new Date(
																location.state.body.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																month: 'short',
															})},2022`}
														</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 5,
														}}>
														<Grid container style={{ alignItems: 'center' }}>
															<Grid item xs={12} sm={3} lg={3}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.da.city}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 600,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.dt.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ marginTop: matches ? 10 : '' }}>
																<Box
																	style={{
																		padding: '2px 20px',
																		background: 'rgb(239, 51, 57)',
																		color: 'white',
																		borderRadius: 25,
																	}}>
																	<BodyText
																		three
																		textStyle={{
																			fontSize: 16,
																			textAlign: 'center',
																			whiteSpace: 'nowrap',
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																		}}>
																		{timeConvert(i.duration)}
																	</BodyText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{
																	textAlign: 'center',
																	marginTop: matches ? 10 : '',
																}}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.aa.city}
																		{/* {i.Destination_City} */}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.at.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ textAlign: 'center' }}>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${i.fD.aI.code}.gif`}
																	width='50px'
																	height='25px'></img>
																<p>{`${i.fD.aI.name} (${i.fD.aI.code}-${i.fD.fN})`}</p>
															</Grid>
														</Grid>
														{/* <Grid container>
				  <Grid item xs={12} sm={9} lg={9}>
					<Box
					  display="flex"
					  justifyContent="space-between"
					>
					  <Box>
						<TitleText
						  textStyle={{
							fontFamily: "unset",
							fontWeight: 500,
							fontSize: 18,
						  }}
						>
						  {i.Origin.Airport.CityName}(
						  {i.Origin.Airport.AirportCode})
						</TitleText>
						<BodyText
						  four
						  textStyle={{
							fontFamily: "unset",
							fontWeight: 500,
						  }}
						>
						  {i.Origin.Airport.AirportName}
						</BodyText>
					  </Box>
					  <Box>
						<TitleText
						  four
						  textStyle={{
							fontFamily: "unset",
							fontWeight: 500,
						  }}
						>
						  {i.Origin.DepTime.substr(11, 5)}
						</TitleText>
					  </Box>
					</Box>
					<Grid container alignItems="center">
					  <Grid item xs={6} lg={9}>
						<Divider />
					  </Grid>
					  <Grid item xs={4} lg={3}>
						<Box
						  style={{
							padding: "2px 20px",
							background: "rgb(239, 51, 57)",
							color: "white",
							borderRadius: 5,
						  }}
						>
						  <BodyText three>
							{timeConvert(i.Duration)}
						  </BodyText>
						</Box>
					  </Grid>
					</Grid>

					<Box
					  display="flex"
					  justifyContent="space-between"
					>
					  <Box>
						<TitleText
						  textStyle={{
							fontFamily: "unset",
							fontWeight: 500,
							fontSize: 18,
						  }}
						>
						  {i.Destination.Airport.CityName}(
						  {i.Destination.Airport.AirportCode})
						</TitleText>
						<BodyText
						  four
						  textStyle={{
							fontFamily: "unset",
							fontWeight: 500,
						  }}
						>
						  {i.Destination.Airport.AirportName}
						</BodyText>
					  </Box>
					  <Box>
						<TitleText
						  four
						  textStyle={{
							fontFamily: "unset",
							fontWeight: 500,
						  }}
						>
						  {i.Destination.ArrTime.substr(11, 5)}
						</TitleText>
					  </Box>
					</Box>
				  </Grid>
				  <Grid item xs={12} sm={3} lg={3}>
					<Box textAlign="center">
					  <img
						src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
						width="50px"
						height="25px"
					  ></img>
					  <BodyText three>
						{i.Airline.AirlineName}
					  </BodyText>
					  <BodyText three>
						{i.Airline.AirlineCode}-
						{i.Airline.FlightNumber}| Economy
					  </BodyText>
					  <BodyText three>
						Check-In : 1Pc - 15Kgs
					  </BodyText>
					  <BodyText three>Cabin : 7Kgs</BodyText>
					</Box>
				  </Grid>
				</Grid> */}
													</Box>
												</>
											);
									  })
									: ''
								: ''}

							{location.state.selectedonward
								? location.state.selectedonward[0].Airline_Code
									? location.state.selectedonward[0].Segments.map(
											(i, index) => {
												return <SelectedOnwardEtravRow i={i} index={index} />;
											}
									  )
									: location.state.selectedonward[0].AirlineCode
									? location.state.selectedonward[0].Segments[0].map(
											(i, index) => {
												return (
													<SelectedOnwardTboRow
														i={i}
														index={index}
														selectedonward={location.state.selectedonward}
													/>
												);
											}
									  )
									: location.state.selectedonward[0].Supplier === 'TJK'
									? location.state.selectedonward[0].sI.map((i, index) => {
											return (
												<SelectedOnwardTJKRow
													i={i}
													index={index}
													selectedonward={location.state.selectedonward}
												/>
											);
									  })
									: ''
								: ''}
							{location.state.intFlight
								? location.state.intFlight.Segments[0].map((i, index) => {
										return (
											<>
												<Box
													display='flex'
													justifyContent='space-between'
													mt={index > 0 ? '20px' : ''}>
													<Box display='flex' alignItems='center'>
														<Box alignItems='center' display='flex'>
															<TitleText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 500,
																	fontSize: 18,
																}}>
																{i.Origin.Airport.CityCode}
															</TitleText>
															-
															<TitleText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 500,
																	fontSize: 18,
																}}>
																{i.Destination.Airport.CityCode}
															</TitleText>
														</Box>
														{index === 0 ? (
															<Box
																ml={'30px'}
																style={{
																	background: 'rgb(239, 51, 57)',
																	padding: '3px 15px',
																	borderRadius: '50px',
																	color: 'white',
																	fontFamily: 'unset',
																	fontWeight: 500,
																}}>
																<TitleText two>ONWARD</TitleText>
															</Box>
														) : (
															''
														)}
													</Box>
													<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
												</Box>
												<Box mt={'20px'}>
													<BodyText three textStyle={{ fontSize: 16 }}>
														{' '}
														{`${new Date(
															location.state.returnBody.Segments[0].PreferredDepartureTime
														).toLocaleString('en-us', {
															weekday: 'short',
														})} ,  ${new Date(
															location.state.returnBody.Segments[0].PreferredDepartureTime
														).getDate()} ${new Date(
															location.state.returnBody.Segments[0].PreferredDepartureTime
														).toLocaleString('en-us', {
															month: 'short',
														})},2022`}
													</BodyText>
												</Box>
												<Box
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														borderRadius: 5,
													}}>
													<Grid container style={{ alignItems: 'center' }}>
														<Grid item xs={12} sm={3} lg={3}>
															<Box
																display={matches ? 'flex' : ''}
																justifyContent={matches ? 'space-between' : ''}
																alignItems={matches ? 'center' : ''}>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.Origin.Airport.CityName}
																	{/* {i.Origin.Airport.AirportCode}) */}
																</TitleText>
																<TitleText
																	three
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 600,
																		fontSize: matches ? 16 : '',
																	}}>
																	{i.Origin.DepTime.substr(11, 5)}
																</TitleText>
															</Box>
														</Grid>
														<Grid
															item
															xs={12}
															sm={3}
															lg={3}
															style={{ marginTop: matches ? 10 : '' }}>
															<Box
																style={{
																	padding: '2px 20px',
																	background: 'rgb(239, 51, 57)',
																	color: 'white',
																	borderRadius: 25,
																}}>
																<BodyText
																	three
																	textStyle={{
																		fontSize: 16,
																		textAlign: 'center',
																		whiteSpace: 'nowrap',
																		overflow: 'hidden',
																		textOverflow: 'ellipsis',
																	}}>
																	{timeConvert(i.Duration)}
																</BodyText>
															</Box>
														</Grid>
														<Grid
															item
															xs={12}
															sm={3}
															lg={3}
															style={{
																textAlign: 'center',
																marginTop: matches ? 10 : '',
															}}>
															<Box
																display={matches ? 'flex' : ''}
																justifyContent={matches ? 'space-between' : ''}
																alignItems={matches ? 'center' : ''}>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.Destination.Airport.CityName}
																	{/* {i.Destination_City} */}
																	{/* {i.Origin.Airport.AirportCode}) */}
																</TitleText>
																<TitleText
																	three
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: matches ? 16 : '',
																	}}>
																	{i.Destination.ArrTime.substr(11, 5)}
																</TitleText>
															</Box>
														</Grid>
														<Grid
															item
															xs={12}
															sm={3}
															lg={3}
															style={{ textAlign: 'center' }}>
															<img
																src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
																width='50px'
																height='25px'></img>
															<p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
														</Grid>
													</Grid>
													{/* <Grid container>
                        <Grid item xs={12} sm={9} lg={9}>
                          <Box
                          display="flex"
                          justifyContent="space-between"
                          >
                          <Box>
                            <TitleText
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                            }}
                            >
                            {i.Origin.Airport.CityName}(
                            {i.Origin.Airport.AirportCode})
                            </TitleText>
                            <BodyText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Origin.Airport.AirportName}
                            </BodyText>
                          </Box>
                          <Box>
                            <TitleText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Origin.DepTime.substr(11, 5)}
                            </TitleText>
                          </Box>
                          </Box>
                          <Grid container alignItems="center">
                          <Grid item xs={6} lg={9}>
                            <Divider />
                          </Grid>
                          <Grid item xs={4} lg={3}>
                            <Box
                            style={{
                              padding: "2px 20px",
                              background: "rgb(239, 51, 57)",
                              color: "white",
                              borderRadius: 5,
                            }}
                            >
                            <BodyText three>
                              {timeConvert(i.Duration)}
                            </BodyText>
                            </Box>
                          </Grid>
                          </Grid>
                  
                          <Box
                          display="flex"
                          justifyContent="space-between"
                          >
                          <Box>
                            <TitleText
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                            }}
                            >
                            {i.Destination.Airport.CityName}(
                            {i.Destination.Airport.AirportCode})
                            </TitleText>
                            <BodyText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Destination.Airport.AirportName}
                            </BodyText>
                          </Box>
                          <Box>
                            <TitleText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Destination.ArrTime.substr(11, 5)}
                            </TitleText>
                          </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={3} lg={3}>
                          <Box textAlign="center">
                          <img
                            src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                            width="50px"
                            height="25px"
                          ></img>
                          <BodyText three>
                            {i.Airline.AirlineName}
                          </BodyText>
                          <BodyText three>
                            {i.Airline.AirlineCode}-
                            {i.Airline.FlightNumber}| Economy
                          </BodyText>
                          <BodyText three>
                            Check-In : 1Pc - 15Kgs
                          </BodyText>
                          <BodyText three>Cabin : 7Kgs</BodyText>
                          </Box>
                        </Grid>
                        </Grid> */}
												</Box>
											</>
										);
								  })
								: ''}
						</Box>

						{location.state.selectedReturn ? (
							<Box
								style={{
									padding: 15,
									background: 'white',
									color: 'gray',
									border: '1px solid #e6e6e6',
									margin: '0 0 20px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								{location.state.selectedReturn[0].Airline_Code
									? location.state.selectedReturn[0].Segments.map(
											(i, index) => {
												return <SelectedReturnEtravRow i={i} index={index} />;
											}
									  )
									: location.state.selectedReturn[0].AirlineCode
									? location.state.selectedReturn[0].Segments[0].map(
											(i, index) => {
												return (
													<>
														<Box
															display='flex'
															justifyContent='space-between'
															mt={index > 0 ? '20px' : ''}>
															<Box display='flex' alignItems='center'>
																<Box alignItems='center' display='flex'>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Origin.Airport.CityCode}
																	</TitleText>
																	-
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Destination.Airport.CityCode}
																	</TitleText>
																</Box>
																<Box
																	ml={'30px'}
																	style={{
																		background: 'rgb(239, 51, 57)',
																		padding: '3px 15px',
																		borderRadius: '50px',
																		color: 'white',
																		fontFamily: 'unset',
																		fontWeight: 500,
																	}}>
																	<TitleText two>ONWARD</TitleText>
																</Box>
															</Box>
															<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
														</Box>
														<Box mt={'20px'}>
															<BodyText three textStyle={{ fontSize: 16 }}>
																{' '}
																{`${new Date(
																	location.state.returnBody.Segments[0].PreferredDepartureTime
																).toLocaleString('en-us', {
																	weekday: 'short',
																})} ,  ${new Date(
																	location.state.returnBody.Segments[0].PreferredDepartureTime
																).getDate()} ${new Date(
																	location.state.returnBody.Segments[0].PreferredDepartureTime
																).toLocaleString('en-us', {
																	month: 'short',
																})},2022`}
															</BodyText>
														</Box>
														<Box
															style={{
																background: 'white',
																padding: '10px 15px',
																border: '1px solid #e6e6e6',
																marginTop: '10px',
																borderRadius: 5,
															}}>
															<Grid container style={{ alignItems: 'center' }}>
																<Grid item xs={12} sm={3} lg={3}>
																	<Box
																		display={matches ? 'flex' : ''}
																		justifyContent={
																			matches ? 'space-between' : ''
																		}
																		alignItems={matches ? 'center' : ''}>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Origin.Airport.CityName}
																			{/* {i.Origin.Airport.AirportCode}) */}
																		</TitleText>
																		<TitleText
																			three
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 600,
																				fontSize: matches ? 16 : '',
																			}}>
																			{i.Origin.DepTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Grid>
																<Grid
																	item
																	xs={12}
																	sm={3}
																	lg={3}
																	style={{ marginTop: matches ? 10 : '' }}>
																	<Box
																		style={{
																			padding: '2px 20px',
																			background: 'rgb(239, 51, 57)',
																			color: 'white',
																			borderRadius: 25,
																		}}>
																		<BodyText
																			three
																			textStyle={{
																				fontSize: 16,
																				textAlign: 'center',
																				whiteSpace: 'nowrap',
																				overflow: 'hidden',
																				textOverflow: 'ellipsis',
																			}}>
																			{timeConvert(i.Duration)}
																		</BodyText>
																	</Box>
																</Grid>
																<Grid
																	item
																	xs={12}
																	sm={3}
																	lg={3}
																	style={{
																		textAlign: 'center',
																		marginTop: matches ? 10 : '',
																	}}>
																	<Box
																		display={matches ? 'flex' : ''}
																		justifyContent={
																			matches ? 'space-between' : ''
																		}
																		alignItems={matches ? 'center' : ''}>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Destination.Airport.CityName}
																			{/* {i.Destination_City} */}
																			{/* {i.Origin.Airport.AirportCode}) */}
																		</TitleText>
																		<TitleText
																			three
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: matches ? 16 : '',
																			}}>
																			{i.Destination.ArrTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Grid>
																<Grid
																	item
																	xs={12}
																	sm={3}
																	lg={3}
																	style={{ textAlign: 'center' }}>
																	<img
																		src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
																		width='50px'
																		height='25px'></img>
																	<p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
																</Grid>
															</Grid>
															{/* <Grid container>
                              <Grid item xs={12} sm={9} lg={9}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Origin.Airport.CityName}(
                                      {i.Origin.Airport.AirportCode})
                                    </TitleText>
                                    <BodyText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Origin.Airport.AirportName}
                                    </BodyText>
                                  </Box>
                                  <Box>
                                    <TitleText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Origin.DepTime.substr(11, 5)}
                                    </TitleText>
                                  </Box>
                                </Box>
                                <Grid container alignItems="center">
                                  <Grid item xs={6} lg={9}>
                                    <Divider />
                                  </Grid>
                                  <Grid item xs={4} lg={3}>
                                    <Box
                                      style={{
                                        padding: "2px 20px",
                                        background: "rgb(239, 51, 57)",
                                        color: "white",
                                        borderRadius: 5,
                                      }}
                                    >
                                      <BodyText three>
                                        {timeConvert(i.Duration)}
                                      </BodyText>
                                    </Box>
                                  </Grid>
                                </Grid>

                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Destination.Airport.CityName}(
                                      {i.Destination.Airport.AirportCode})
                                    </TitleText>
                                    <BodyText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Destination.Airport.AirportName}
                                    </BodyText>
                                  </Box>
                                  <Box>
                                    <TitleText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Destination.ArrTime.substr(11, 5)}
                                    </TitleText>
                                  </Box>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3}>
                                <Box textAlign="center">
                                  <img
                                    src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                                    width="50px"
                                    height="25px"
                                  ></img>
                                  <BodyText three>
                                    {i.Airline.AirlineName}
                                  </BodyText>
                                  <BodyText three>
                                    {i.Airline.AirlineCode}-
                                    {i.Airline.FlightNumber}| Economy
                                  </BodyText>
                                  <BodyText three>
                                    Check-In : 1Pc - 15Kgs
                                  </BodyText>
                                  <BodyText three>Cabin : 7Kgs</BodyText>
                                </Box>
                              </Grid>
                            </Grid> */}
														</Box>
													</>
												);
											}
									  )
									: location.state.selectedReturn[0].Supplier === 'TJK'
									? location.state.selectedReturn[0].sI.map((i, index) => {
											return (
												<SelectedOnwardTJKRow
													i={i}
													index={index}
													selectedReturn={location.state.selectedReturn}
												/>
											);
									  })
									: ''}
							</Box>
						) : (
							''
						)}
						{location.state.intFlight ? (
							<Box
								style={{
									padding: 15,
									background: 'white',
									color: 'gray',
									border: '1px solid #e6e6e6',
									margin: '0 0 20px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								{location.state.intFlight
									? location.state.intFlight.Segments[1].map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.Origin.Airport.CityCode}
																</TitleText>
																-
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.Destination.Airport.CityCode}
																</TitleText>
															</Box>
															{index === 0 ? (
																<Box
																	ml={'30px'}
																	style={{
																		background: 'rgb(239, 51, 57)',
																		padding: '3px 15px',
																		borderRadius: '50px',
																		color: 'white',
																		fontFamily: 'unset',
																		fontWeight: 500,
																	}}>
																	<TitleText two>RETRUN</TitleText>
																</Box>
															) : (
																''
															)}
														</Box>
														<Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText three textStyle={{ fontSize: 16 }}>
															{' '}
															{`${new Date(
																location.state.returnBody.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																weekday: 'short',
															})} ,  ${new Date(
																location.state.returnBody.Segments[0].PreferredDepartureTime
															).getDate()} ${new Date(
																location.state.returnBody.Segments[0].PreferredDepartureTime
															).toLocaleString('en-us', {
																month: 'short',
															})},2022`}
														</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 5,
														}}>
														<Grid container style={{ alignItems: 'center' }}>
															<Grid item xs={12} sm={3} lg={3}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Origin.Airport.CityName}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 600,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.Origin.DepTime.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ marginTop: matches ? 10 : '' }}>
																<Box
																	style={{
																		padding: '2px 20px',
																		background: 'rgb(239, 51, 57)',
																		color: 'white',
																		borderRadius: 25,
																	}}>
																	<BodyText
																		three
																		textStyle={{
																			fontSize: 16,
																			textAlign: 'center',
																			whiteSpace: 'nowrap',
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																		}}>
																		{timeConvert(i.Duration)}
																	</BodyText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{
																	textAlign: 'center',
																	marginTop: matches ? 10 : '',
																}}>
																<Box
																	display={matches ? 'flex' : ''}
																	justifyContent={
																		matches ? 'space-between' : ''
																	}
																	alignItems={matches ? 'center' : ''}>
																	<TitleText
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: 18,
																		}}>
																		{i.Destination.Airport.CityName}
																		{/* {i.Destination_City} */}
																		{/* {i.Origin.Airport.AirportCode}) */}
																	</TitleText>
																	<TitleText
																		three
																		textStyle={{
																			fontFamily: 'unset',
																			fontWeight: 500,
																			fontSize: matches ? 16 : '',
																		}}>
																		{i.Destination.ArrTime.substr(11, 5)}
																	</TitleText>
																</Box>
															</Grid>
															<Grid
																item
																xs={12}
																sm={3}
																lg={3}
																style={{ textAlign: 'center' }}>
																<img
																	src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
																	width='50px'
																	height='25px'></img>
																<p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
															</Grid>
														</Grid>
														{/* <Grid container>
                          <Grid item xs={12} sm={9} lg={9}>
                            <Box
                            display="flex"
                            justifyContent="space-between"
                            >
                            <Box>
                              <TitleText
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                                fontSize: 18,
                              }}
                              >
                              {i.Origin.Airport.CityName}(
                              {i.Origin.Airport.AirportCode})
                              </TitleText>
                              <BodyText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Origin.Airport.AirportName}
                              </BodyText>
                            </Box>
                            <Box>
                              <TitleText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Origin.DepTime.substr(11, 5)}
                              </TitleText>
                            </Box>
                            </Box>
                            <Grid container alignItems="center">
                            <Grid item xs={6} lg={9}>
                              <Divider />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                              <Box
                              style={{
                                padding: "2px 20px",
                                background: "rgb(239, 51, 57)",
                                color: "white",
                                borderRadius: 5,
                              }}
                              >
                              <BodyText three>
                                {timeConvert(i.Duration)}
                              </BodyText>
                              </Box>
                            </Grid>
                            </Grid>
                    
                            <Box
                            display="flex"
                            justifyContent="space-between"
                            >
                            <Box>
                              <TitleText
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                                fontSize: 18,
                              }}
                              >
                              {i.Destination.Airport.CityName}(
                              {i.Destination.Airport.AirportCode})
                              </TitleText>
                              <BodyText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Destination.Airport.AirportName}
                              </BodyText>
                            </Box>
                            <Box>
                              <TitleText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Destination.ArrTime.substr(11, 5)}
                              </TitleText>
                            </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3} lg={3}>
                            <Box textAlign="center">
                            <img
                              src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                              width="50px"
                              height="25px"
                            ></img>
                            <BodyText three>
                              {i.Airline.AirlineName}
                            </BodyText>
                            <BodyText three>
                              {i.Airline.AirlineCode}-
                              {i.Airline.FlightNumber}| Economy
                            </BodyText>
                            <BodyText three>
                              Check-In : 1Pc - 15Kgs
                            </BodyText>
                            <BodyText three>Cabin : 7Kgs</BodyText>
                            </Box>
                          </Grid>
                          </Grid> */}
													</Box>
												</>
											);
									  })
									: ''}
							</Box>
						) : (
							''
						)}
						<Box display='flex' alignItems='center'>
							<TitleText
								textStyle={{
									fontFamily: 'Josefin Sans, sans-serif',
									fontWeight: 500,
									fontSize: 20,
								}}>
								Contact Information{' '}
							</TitleText>
							{/* <TitleText
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										fontSize: 20,
									}}>
									<span
										style={{
											color: 'blue',
											fontWeight: 500,
											cursor: 'pointer',
											fontSize: 20,
										}}
										// onClick={() => dispatch(toggleLoginModal(true))}
									>
										Sign in
									</span>{' '}
									to book faster and avail offers.{' '}
								</TitleText> */}
						</Box>
						{true ? (
							<FlightConfirmForm
								item={location.state.OneflightData}
								value={value}
							/>
						) : (
							<FlightConfirmReturnForm
								item={location.state.OneflightData}
								value={value}
							/>
						)}
						{/* <FlightConfirmForm
								item={location.state.OneflightData}
								value={value}
							/> */}
					</Grid>
					<Grid item xs={12} lg={4}>
					<Box style={{ position: "sticky", top: 84 }}>
              <Box
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "62px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                  // position: 'sticky',
                  // top: 84,
                  zIndex: 1,
                }}
              >
                <Grid container alignItems="center">
                  <Grid item xs={4}>
                    Fare Details
                  </Grid>
                  <Grid item xs={8}>
                    <Divider style={{ background: "black" }} />
                  </Grid>
                </Grid>
                <Box
                  style={{
                    background: "rgba(57,201,187,.17)",
                    padding: "5px 10px",
                    margin: "10px 0 0",
                    borderRadius: "15px",
                  }}
                >
                  <BodyText textStyle={{ fontSize: 13 }}>
                    AMOUNT TO BE PAID
                  </BodyText>
                  <TitleText textStyle={{ fontSize: 18 }}>
                    {location.state.returnBody
                      ? location.state.intFlight
                        ? `${curr} ${Number(Math.round(Number(
                            Math.round(
                              location.state.intFlight.Fare.Total_Amount
                            )
                          )))}`
                        : `${curr} ${Number(Math.round(Number(
                            Number(
                              Math.round(
                                location.state.selectedonward[0].Airline_Code
                                  ? location.state.selectedonward[0].Fares
                                      .Total_Amount
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedonward[0].Fare
                                      .Total_Amount
                                  : 0
                              )
                            ) +
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Airline_Code
                                    ? location.state.selectedReturn[0].Fares
                                        .Total_Amount
                                    : location.state.selectedonward[0]
                                        .AirlineCode
                                    ? location.state.selectedReturn[0].Fare
                                        .Total_Amount
                                    : 0
                                )
                              ) -
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Airline_Code
                                    ? 0
                                    : location.state.selectedonward[0]
                                        .AirlineCode
                                    ? location.state.selectedReturn[0].Fare
                                        .MFB_Discount
                                    : 0
                                )
                              ) -
                              Number(
                                Math.round(
                                  location.state.selectedonward[0].Airline_Code
                                    ? 0
                                    : location.state.selectedonward[0]
                                        .AirlineCode
                                    ? location.state.selectedonward[0].Fare
                                        .MFB_Discount
                                    : 0
                                )
                              )
                          )))}`
                      : location.state.OneflightData
                      ? `${curr} ${
                          Number(Math.round(Number(Number(
                            location.state.OneflightData.Supplier === "ETR"
                              ? Math.round(
                                  location.state.OneflightData.Fares
                                    .Total_Amount
                                )
                              : location.state.OneflightData.Supplier === "TBO"
                              ? Math.round(
                                  location.state.OneflightData.Fare.Total_Amount
                                )
                              : location.state.OneflightData.Supplier === "TJK"
                              ? Math.round(
                                  location.state.OneflightData.totalPriceList.fd
                                    .Total_Amount
                                )
                              : ""
                          ) +
                          Number(
                            Math.round(
                              baggageAdult1?.AirlineCode
                                ? baggageAdult1?.Price
                                : baggageAdult1?.code
                                ? baggageAdult1?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult2?.AirlineCode
                                ? baggageAdult2?.Price
                                : baggageAdult2?.code
                                ? baggageAdult2?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult3?.AirlineCode
                                ? baggageAdult3?.Price
                                : baggageAdult3?.code
                                ? baggageAdult3?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult4?.AirlineCode
                                ? baggageAdult4?.Price
                                : baggageAdult4?.code
                                ? baggageAdult4?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult5?.AirlineCode
                                ? baggageAdult5?.Price
                                : baggageAdult5?.code
                                ? baggageAdult5?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult6?.AirlineCode
                                ? baggageAdult6?.Price
                                : baggageAdult6?.code
                                ? baggageAdult6?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult7?.AirlineCode
                                ? baggageAdult7?.Price
                                : baggageAdult7?.code
                                ? baggageAdult7?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult8?.AirlineCode
                                ? baggageAdult8?.Price
                                : baggageAdult8?.code
                                ? baggageAdult8?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageAdult9?.AirlineCode
                                ? baggageAdult9?.Price
                                : baggageAdult9?.code
                                ? baggageAdult9?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageChild1?.AirlineCode
                                ? baggageChild1?.Price
                                : baggageChild1?.code
                                ? baggageChild1?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageChild2?.AirlineCode
                                ? baggageChild2?.Price
                                : baggageChild2?.code
                                ? baggageChild2?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageChild3?.AirlineCode
                                ? baggageChild3?.Price
                                : baggageChild3?.code
                                ? baggageChild3?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageChild4?.AirlineCode
                                ? baggageChild4?.Price
                                : baggageChild4?.code
                                ? baggageChild4?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageChild5?.AirlineCode
                                ? baggageChild5?.Price
                                : baggageChild5?.code
                                ? baggageChild5?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              baggageChild6?.AirlineCode
                                ? baggageChild6?.Price
                                : baggageChild6?.code
                                ? baggageChild6?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult1?.AirlineCode
                                ? mealAdult1?.Price
                                : mealAdult1?.code
                                ? mealAdult1?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult2?.AirlineCode
                                ? mealAdult2?.Price
                                : mealAdult2?.code
                                ? mealAdult2?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult3?.AirlineCode
                                ? mealAdult3?.Price
                                : mealAdult3?.code
                                ? mealAdult3?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult4?.AirlineCode
                                ? mealAdult4?.Price
                                : mealAdult4?.code
                                ? mealAdult4?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult5?.AirlineCode
                                ? mealAdult5?.Price
                                : mealAdult5?.code
                                ? mealAdult5?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult6?.AirlineCode
                                ? mealAdult6?.Price
                                : mealAdult6?.code
                                ? mealAdult6?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult7?.AirlineCode
                                ? mealAdult7?.Price
                                : mealAdult7?.code
                                ? mealAdult7?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult8?.AirlineCode
                                ? mealAdult8?.Price
                                : mealAdult8?.code
                                ? mealAdult8?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealAdult9?.AirlineCode
                                ? mealAdult9?.Price
                                : mealAdult9?.code
                                ? mealAdult9?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealChild1?.AirlineCode
                                ? mealChild1?.Price
                                : mealChild1?.code
                                ? mealChild1?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealChild2?.AirlineCode
                                ? mealChild2?.Price
                                : mealChild2?.code
                                ? mealChild2?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealChild3?.AirlineCode
                                ? mealChild3?.Price
                                : mealChild3?.code
                                ? mealChild3?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealChild4?.AirlineCode
                                ? mealChild4?.Price
                                : mealChild4?.code
                                ? mealChild4?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealChild5?.AirlineCode
                                ? mealChild5?.Price
                                : mealChild5?.code
                                ? mealChild5?.amount
                                : 0
                            )
                          ) +
                          Number(
                            Math.round(
                              mealChild6?.AirlineCode
                                ? mealChild6?.Price
                                : mealChild6?.code
                                ? mealChild6?.amount
                                : 0
                            )
                          ))))
                        }`
                      : ""}
                  </TitleText>
                  <span>(inclusive of all taxes.)</span>
                </Box>
                <Box display="flex" justifyContent="space-between" mt={"10px"}>
                  <BodyText textStyle={{ fontSize: 13 }}>
                    Adultx
                    {location.state.body
                      ? location.state.body.AdultCount
                      : location.state.returnBody
                      ? location.state.returnBody.AdultCount
                      : ""}
                  </BodyText>
                  <TitleText textStyle={{ fontSize: 13 }}>
                    {location.state.returnBody
                      ? location.state.intFlight
                        ? `${curr} ${Number(Math.round(Number(
                            Math.round(
                              location.state.intFlight.Fare.Basic_Amount
                            )
                          )))}`
                        : `₹ ${Number(Math.round(Number(
                            Number(
                              Math.round(
                                location.state.selectedonward[0].Airline_Code
                                  ? location.state.selectedonward[0].Fares
                                      .Basic_Amount
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedonward[0].Fare
                                      .Basic_Amount
                                  : 0
                              )
                            ) +
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Airline_Code
                                    ? location.state.selectedReturn[0].Fares
                                        .Basic_Amount
                                    : location.state.selectedonward[0]
                                        .AirlineCode
                                    ? location.state.selectedReturn[0].Fare
                                        .Basic_Amount
                                    : 0
                                )
                              )
                          )))}`
                      : location.state.OneflightData
                      ? `${curr} ${Number(Math.round(Number(
                          location.state.OneflightData.Supplier === "ETR"
                            ? Math.round(
                                location.state.OneflightData.Fares.Basic_Amount
                              )
                            : location.state.OneflightData.Supplier === "TBO"
                            ? Math.round(
                                location.state.OneflightData.Fare.Basic_Amount
                              )
                            : location.state.OneflightData.Supplier === "TJK"
                            ? Math.round(
                                location.state.OneflightData.totalPriceList.fd
                                  .Basic_Amount
                              )
                            : ""
                        )))}`
                      : ""}
                  </TitleText>
                </Box>
                {baggageAdult1 ||
                baggageAdult2 ||
                baggageAdult3 ||
                baggageAdult4 ||
                baggageAdult5 ||
                baggageAdult6 ||
                baggageAdult7 ||
                baggageAdult8 ||
                baggageAdult9 ||
                baggageChild1 ||
                baggageChild2 ||
                baggageChild3 ||
                baggageChild4 ||
                baggageChild5 ||
                baggageChild6 ||
                mealAdult1 ||
                mealAdult2 ||
                mealAdult3 ||
                mealAdult4 ||
                mealAdult5 ||
                mealAdult6 ||
                mealAdult7 ||
                mealAdult8 ||
                mealAdult9 ||
                mealChild1 ||
                mealChild2 ||
                mealChild3 ||
                mealChild4 ||
                mealChild5 ||
                mealChild6 ? (
                  <Box display="flex" justifyContent="space-between">
                    <BodyText textStyle={{ fontSize: 13 }}>Add-Ons</BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
					<span style={{marginRight:5}}>{curr}</span>
                      {Number(Math.round(Number(Number(
                        Math.round(
                          baggageAdult1?.AirlineCode
                            ? baggageAdult1?.Price
                            : baggageAdult1?.code
                            ? baggageAdult1?.amount
                            : 0
                        )
                      ) +
                        Number(
                          Math.round(
                            baggageAdult2?.AirlineCode
                              ? baggageAdult2?.Price
                              : baggageAdult2?.code
                              ? baggageAdult2?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult3?.AirlineCode
                              ? baggageAdult3?.Price
                              : baggageAdult3?.code
                              ? baggageAdult3?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult4?.AirlineCode
                              ? baggageAdult4?.Price
                              : baggageAdult4?.code
                              ? baggageAdult4?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult5?.AirlineCode
                              ? baggageAdult5?.Price
                              : baggageAdult5?.code
                              ? baggageAdult5?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult6?.AirlineCode
                              ? baggageAdult6?.Price
                              : baggageAdult6?.code
                              ? baggageAdult6?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult7?.AirlineCode
                              ? baggageAdult7?.Price
                              : baggageAdult7?.code
                              ? baggageAdult7?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult8?.AirlineCode
                              ? baggageAdult8?.Price
                              : baggageAdult8?.code
                              ? baggageAdult8?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageAdult9?.AirlineCode
                              ? baggageAdult9?.Price
                              : baggageAdult9?.code
                              ? baggageAdult9?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageChild1?.AirlineCode
                              ? baggageChild1?.Price
                              : baggageChild1?.code
                              ? baggageChild1?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageChild2?.AirlineCode
                              ? baggageChild2?.Price
                              : baggageChild2?.code
                              ? baggageChild2?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageChild3?.AirlineCode
                              ? baggageChild3?.Price
                              : baggageChild3?.code
                              ? baggageChild3?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageChild4?.AirlineCode
                              ? baggageChild4?.Price
                              : baggageChild4?.code
                              ? baggageChild4?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageChild5?.AirlineCode
                              ? baggageChild5?.Price
                              : baggageChild5?.code
                              ? baggageChild5?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            baggageChild6?.AirlineCode
                              ? baggageChild6?.Price
                              : baggageChild6?.code
                              ? baggageChild6?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult1?.AirlineCode
                              ? mealAdult1?.Price
                              : mealAdult1?.code
                              ? mealAdult1?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult2?.AirlineCode
                              ? mealAdult2?.Price
                              : mealAdult2?.code
                              ? mealAdult2?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult3?.AirlineCode
                              ? mealAdult3?.Price
                              : mealAdult3?.code
                              ? mealAdult3?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult4?.AirlineCode
                              ? mealAdult4?.Price
                              : mealAdult4?.code
                              ? mealAdult4?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult5?.AirlineCode
                              ? mealAdult5?.Price
                              : mealAdult5?.code
                              ? mealAdult5?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult6?.AirlineCode
                              ? mealAdult6?.Price
                              : mealAdult6?.code
                              ? mealAdult6?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult7?.AirlineCode
                              ? mealAdult7?.Price
                              : mealAdult7?.code
                              ? mealAdult7?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult8?.AirlineCode
                              ? mealAdult8?.Price
                              : mealAdult8?.code
                              ? mealAdult8?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealAdult9?.AirlineCode
                              ? mealAdult9?.Price
                              : mealAdult9?.code
                              ? mealAdult9?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealChild1?.AirlineCode
                              ? mealChild1?.Price
                              : mealChild1?.code
                              ? mealChild1?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealChild2?.AirlineCode
                              ? mealChild2?.Price
                              : mealChild2?.code
                              ? mealChild2?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealChild3?.AirlineCode
                              ? mealChild3?.Price
                              : mealChild3?.code
                              ? mealChild3?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealChild4?.AirlineCode
                              ? mealChild4?.Price
                              : mealChild4?.code
                              ? mealChild4?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealChild5?.AirlineCode
                              ? mealChild5?.Price
                              : mealChild5?.code
                              ? mealChild5?.amount
                              : 0
                          )
                        ) +
                        Number(
                          Math.round(
                            mealChild6?.AirlineCode
                              ? mealChild6?.Price
                              : mealChild6?.code
                              ? mealChild6?.amount
                              : 0
                          )
                        ))))}
                    </TitleText>
                  </Box>
                ) : (
                  ""
                )}

                <Box display="flex" justifyContent="space-between">
                  <BodyText textStyle={{ fontSize: 13 }}>Total Taxes</BodyText>
                  <TitleText textStyle={{ fontSize: 13 }}>
                    {location.state.returnBody
                      ? location.state.intFlight
                        ? `${curr} ${Number(Math.round(Number(
                            Math.round(
                              location.state.intFlight.Fare.AirportTax_Amount
                            )
                          )))}`
                        : `₹ ${Number(Math.round(Number(
                            Number(
                              Math.round(
                                location.state.selectedonward[0].Airline_Code
                                  ? location.state.selectedonward[0].Fares
                                      .AirportTax_Amount
                                  : location.state.selectedonward[0].AirlineCode
                                  ? location.state.selectedonward[0].Fare
                                      .AirportTax_Amount
                                  : 0
                              )
                            ) +
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Airline_Code
                                    ? location.state.selectedReturn[0].Fares
                                        .AirportTax_Amount
                                    : location.state.selectedonward[0]
                                        .AirlineCode
                                    ? location.state.selectedReturn[0].Fare
                                        .AirportTax_Amount
                                    : 0
                                )
                              )
                          )))}`
                      : location.state.OneflightData
                      ? `${curr} ${Number(Math.round(Number(
                          location.state.OneflightData.Supplier === "ETR"
                            ? Math.round(
                                location.state.OneflightData.Fares
                                  .AirportTax_Amount
                              )
                            : location.state.OneflightData.Supplier === "TBO"
                            ? Math.round(
                                location.state.OneflightData.Fare
                                  .AirportTax_Amount
                              )
                            : location.state.OneflightData.Supplier === "TJK"
                            ? Math.round(
                                location.state.OneflightData.totalPriceList.fd
                                  .AirportTax_Amount
                              )
                            : ""
                        )))}`
                      : ""}
                  </TitleText>
                </Box>
                <Divider />
                {value ? (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={"5px"}
                    mb={"5px"}
                  >
                    <BodyText>Convenience Fees</BodyText>
                    <TitleText two>Rs 200</TitleText>
                  </Box>
                ) : (
                  ""
                )}

                <Divider />
              </Box>
              {/* <Box
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
										// position: 'sticky',
										// top: value ? 320 : 275,
										zIndex: 1,
									}}>
									<Grid container alignItems='center'>
										<Grid item xs={4}>
											Promo Code
										</Grid>
										<Grid item xs={8}>
											<Divider style={{ background: 'black' }} />
										</Grid>
									</Grid>
									<Box className={classes.radio}>
										<RadioGroup
											aria-label='gender'
											name='gender1'
											value={value}
											// onChange={handleChange}
										>
											<FormControlLabel
												value='female'
												control={<Radio onClick={handleClick} />}
												label='NOFEES'
											/>
											<BodyText three textStyle={{ marginLeft: 10 }}>
												Use this promo ad save 200
											</BodyText>
										</RadioGroup>
									</Box>
								</Box> */}
            </Box>
					</Grid>
				</Grid>
				{/* </Container> */}
			</Box>
			<Footer />
			<AddGSTModal />
			<TermConditionModal />
			<Drawers />
			<Login />
			<ErrorModal />
		</>
	);
};

export default ConfirmFlight;
